<template>
  <view v-if="!userStore.isLogin" @click.stop="handleAuthClick">









    <view class="c-open-type-button" @click="handleGoLogin"></view>

  </view>
</template>

<script setup lang="ts">
import { CONFIRM_EVENT, OPENID_KEY, PAGE_PATH, TOKEN } from '@/constants';
import { fetchWechatPhoneDocument } from '@/services/graphql/docs';
import { fetcher } from '@/services/graphql/fetcher/index';
import { useUserStore } from '@/store';
import { businessUtils, storage, toast } from '@/utils';
import { toRefs } from 'vue';

const emits = defineEmits([CONFIRM_EVENT]);

interface Props {
  /** 登录完成回调 */
  authConfirmCallback?: null | (() => void);
}
const props = withDefaults(defineProps<Props>(), {});
const { authConfirmCallback } = toRefs(props);

const userStore = useUserStore();

const handleGoLogin = () => {
  uni.navigateTo({ url: PAGE_PATH.login.route });
};

const handleAuthClick = () => {};

const getAuthResult = async (jsCode: string) => {
  try {
    const openIdKey = storage.get(OPENID_KEY);

    if (openIdKey) {
      const res = await fetcher.mutation(fetchWechatPhoneDocument, {
        args: {
          jsCode,
          openIdKey,
        },
      });

      const token = res.data?.getWechatPhone?.token;
      if (token) {
        // 缓存token，删除openIdKey
        storage.set(TOKEN, token, 24);
        storage.remove(OPENID_KEY);

        // 更改登录状态
        userStore.isLogin = true;

        console.log('<登录成功>');

        // 如果有登录完成的回调则执行
        authConfirmCallback?.value?.();

        emits(CONFIRM_EVENT, true);
      } else {
        toast.message('登录失败');

        emits(CONFIRM_EVENT, false);
      }
    } else {
      console.log(
        '<本地openIdKey不存在，原因：loginExternal => 没有返回openIdKey或者本地openIdKey已超时被清除>'
      );
      businessUtils.login.exection();
    }
  } catch (error) {
    console.log(error);
  }
};

/** 获取用户手机号 */
const getPhoneNumber = (e: AnyObject) => {
  e.stopPropagation();

  const code = e.detail.code;
  if (!code) {
    console.log('<手机号获取失败>');
    return;
  }
  getAuthResult(code);
};
</script>

<style scoped lang="scss">
</style>
